var map = {
	"./000002 copy/lang/ar-SA.json": [
		69091,
		91
	],
	"./000002 copy/lang/en-US.json": [
		18499,
		499
	],
	"./000002 copy/lang/tr-TR.json": [
		80886,
		886
	],
	"./000002/lang/ar-SA.json": [
		92908,
		908
	],
	"./000002/lang/en-US.json": [
		82624,
		624
	],
	"./000002/lang/tr-TR.json": [
		69277,
		277
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79;
module.exports = webpackAsyncContext;